import { EmailEventPayload } from 'generated-service-lib/EventService';
import { GeneratedEventService } from '../generatedServices';

export class EventService {
  readonly unvalidatedClient: GeneratedEventService;
  constructor(domain?: string) {
    this.unvalidatedClient = new GeneratedEventService(domain);
  }

  sendPlainTextEmail = async (body: EmailEventPayload) =>
    this.unvalidatedClient
      .postEventSimpleemail({ body })
      .then((res) => (typeof res.body === 'undefined' ? {} : res.body));
}
